import _ from 'lodash';

import DecimalForGlobals from '../impuestos/DecimalForGlobals';

class AerolineasOtrosCargosCalculator {

  data = {}

  constructor(data) {
    this.data = data;
  }

  static make(data) {
    return new AerolineasOtrosCargosCalculator(data);
  }

  get() {
    const TotalCargos = this.getTotalCargos();

    return { TotalCargos }
  }

  getTotalCargos() {
    const exept = [];

    const total = _.sumBy(this._getCargos(exept), (item) => {
      return parseFloat(item.Importe);
    });

    return total !== undefined ? DecimalForGlobals.make(total).toFixed() : undefined;
  }

  _getCargos(haystack = [], flag = 0) {
    if (flag === 1) {
      return this.data.filter((item) => {
        return haystack.indexOf(item.CodigoCargo) !== -1;
      });
    }

    return this.data.filter((item) => {
      return haystack.indexOf(item.CodigoCargo) === -1;
    });
  }
}

export default AerolineasOtrosCargosCalculator;